import { ComponentDTO } from './component';

export class ComponentFullDTO extends ComponentDTO {

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);
		Object.assign(this, attributes);
    }

}